import React, { Component, PropTypes } from 'react'
import classNames from 'classnames'

import StampGrid from './StampGrid'
import PaintFillChooser from './PaintFillChooser'
import Price from './Price'

class StampChooser extends Component {
  render() {
    const { enabled,
      stampLoc, stamps, selectedStamp, paintLoc, paints, selectedPaint, selectedWeight,
      isError, isPaintError,
      onCheck, onSelectStamp, onSelectPaintFill, noCheck } = this.props;
    return (
      <div className="stamps-chooser">
        <div className={classNames({ "error": isError }) + ' side-checkbox'}>
          <label className={(!!enabled) ? 'option-selected' : ''}>
            {noCheck || 
              <span>
                <div className={(!!enabled ? 'option-selected' : '') + ' checkbox-target'}></div>
              <input type="checkbox"
                checked={!!enabled /* avoid uncontrolled input */}
                onChange={(evt) => onCheck(!enabled)} />
              </span>
            }
            {stampLoc.label}
            {stamps[0].price > 0 && 
              <Price value={stamps[0].price} />
            }
          </label>
        </div>
        {(enabled || noCheck) &&
            <div>
              <StampGrid
                stamps={stamps}
                selectedStamp={selectedStamp}
                selectedWeight={selectedWeight}
                onSelectStamp={(stamp) => onSelectStamp(stamp.id)}
              />
              <PaintFillChooser key={paintLoc.id}
                loc={paintLoc}
                paints={paints}
                selectedPaint={selectedPaint}
                isError={isPaintError}
                onSelectPaintFill={(paint) => onSelectPaintFill(paintLoc.id, paint.id)}
                isOpen={true}
              />
            </div>
          }
      </div>
    )
  }
}

StampChooser.defaultProps = {
  isError: false,
  isPaintError: false
}

StampChooser.propTypes = {
  stampLoc: PropTypes.object.isRequired,
  stamps: PropTypes.arrayOf(PropTypes.object).isRequired,
  paintLoc: PropTypes.object.isRequired,
  enabled: PropTypes.bool,
  selectedStamp: PropTypes.object,
  paints: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedPaint: PropTypes.object.isRequired,
  onCheck: PropTypes.func,
  onSelectStamp: PropTypes.func.isRequired,
  onSelectPaintFill: PropTypes.func.isRequired,
  noCheck: PropTypes.bool,
}

StampChooser.defaultProps = {
  noCheck: false
}


export default StampChooser